// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Maturity Analysis — print / PDF export (polished layout) */

.ma-pdf-print-host {
  position: fixed;
  left: -10000px;
  top: 0;
  width: 210mm;
  background: #fff;
  z-index: -1;
  pointer-events: none;
  /* Keep in layout for React; capture uses a clone, not this host */
}

.ma-pdf {
  box-sizing: border-box;
  width: 794px;
  max-width: 794px;
  min-height: 0;
  padding: 0 0 40px;
  margin: 0;
  background: #fff;
  color: #0b1e2d;
  font-family: Lato, Helvetica, Arial, sans-serif;
  print-color-adjust: exact !important;
  letter-spacing: 0 !important;
  word-spacing: normal !important;
  zoom: 1;
}

.ma-pdf *,
.ma-pdf *::before,
.ma-pdf *::after {
  box-sizing: border-box;
  print-color-adjust: exact !important;
  /* html2canvas corrupts non-zero letter-spacing (overlap / missing spaces) */
  letter-spacing: 0 !important;
  word-spacing: normal !important;
}

/* ——— Hero ——— */
.ma-pdf-hero {
  margin: 0 0 16px;
  padding: 60px 60px 14px;
  background:
    linear-gradient(135deg, #00146d 0%, #062a63 42%, #076b5c 100%);
  color: #fff;
}

.ma-pdf-hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.ma-pdf-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.ma-pdf-brand-mark {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.12);
  overflow: hidden;
  display: grid;
  place-items: center;
}

.ma-pdf-brand-mark img {
  width: 26px;
  height: 26px;
  object-fit: contain;
  display: block;
}

.ma-pdf-brand-name {
  display: block;
  font-size: 15px;
  font-weight: 800;

  color: #fff;
}

.ma-pdf-brand-tag {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  font-weight: 600;

  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
}

.ma-pdf-date-chip {
  text-align: right;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.ma-pdf-date-label {
  display: block;
  font-size: 9.5px;
  font-weight: 700;

  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 2px;
}

.ma-pdf-date-chip strong {
  font-size: 12.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #fff;
}

.ma-pdf-eyebrow {
  margin: 0 0 6px;
  font-size: 10.5px;
  font-weight: 700;

  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
}

.ma-pdf-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  line-height: 1.15;

}

.ma-pdf-sub {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.82);
  max-width: 540px;
}

.ma-pdf-scale {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
}

.ma-pdf-scale-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.ma-pdf-scale-item i {
  width: 9px;
  height: 9px;
  border-radius: 99px;
  display: inline-block;
}

/* ——— Section labels / body padding ——— */
.ma-pdf-section-label {
  margin: 0 60px 8px;
  font-size: 10px;
  font-weight: 800;

  text-transform: uppercase;
  color: #8a9ba7;
}

.ma-pdf-kpi-grid,
.ma-pdf-card,
.ma-pdf-summary,
.ma-pdf-footer {
  margin-left: 60px;
  margin-right: 60px;
}

/* ——— KPIs ——— */
.ma-pdf-kpi-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 18px;
}

.ma-pdf-kpi {
  position: relative;
  background: #f7fafa;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  padding: 14px 16px 14px 18px;
  overflow: hidden;
}

.ma-pdf-kpi::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: #cdd8d6;
}

.ma-pdf-kpi--teal::before {
  background: #0d9b87;
}

.ma-pdf-kpi--deep::before {
  background: #076b5c;
}

.ma-pdf-kpi--amber::before {
  background: #c98a16;
}

.ma-pdf-kpi--coral::before {
  background: #d14a3e;
}

.ma-pdf-kpi--muted::before {
  background: #8a9ba7;
}

.ma-pdf-kpi-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.ma-pdf-kpi-label {
  margin: 0;
  font-size: 10px;
  font-weight: 700;

  text-transform: uppercase;
  color: #5f7484;
  line-height: 1.35;
  max-width: 70%;
}

.ma-pdf-pill {
  flex: none;
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 99px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.ma-pdf-pill--teal {
  background: #e1f4f0;
  color: #076b5c;
}

.ma-pdf-pill--deep {
  background: #d5ebe6;
  color: #054f44;
}

.ma-pdf-pill--amber {
  background: #faefda;
  color: #84540a;
}

.ma-pdf-pill--coral {
  background: #fae6e3;
  color: #96271b;
}

.ma-pdf-pill--muted {
  background: #eaf0f0;
  color: #5f7484;
}

.ma-pdf-kpi-value {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.05;
  color: #0b1e2d;
  font-variant-numeric: tabular-nums;
}

.ma-pdf-kpi-value.is-teal {
  color: #076b5c;
}

.ma-pdf-kpi-value.is-deep {
  color: #054f44;
}

.ma-pdf-kpi-value.is-amber {
  color: #c98a16;
}

.ma-pdf-kpi-value.is-coral {
  color: #d14a3e;
}

.ma-pdf-kpi-value.is-muted {
  color: #8a9ba7;
}

.ma-pdf-kpi-desc {
  margin: 8px 0 0;
  font-size: 11px;
  line-height: 1.45;
  color: #5f7484;
}

.ma-pdf-bar {
  height: 8px;
  border-radius: 99px;
  background: #eaf0f0;
  margin-top: 12px;
  overflow: hidden;
}

.ma-pdf-bar span {
  display: block;
  height: 100%;
  border-radius: 99px;
  min-width: 0;
}

.ma-pdf-bar--row {
  margin-top: 0;
  height: 10px;
}

/* ——— Summary strip ——— */
.ma-pdf-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 10px;
}

.ma-pdf-summary-item {
  background: #f7fafa;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  padding: 10px 12px;
}

.ma-pdf-summary-item span {
  display: block;
  font-size: 9.5px;
  font-weight: 700;

  text-transform: uppercase;
  color: #8a9ba7;
  margin-bottom: 4px;
}

.ma-pdf-summary-item strong {
  font-size: 18px;
  font-weight: 700;
  color: #0b1e2d;
  font-variant-numeric: tabular-nums;
}

.ma-pdf-summary-item strong.is-teal {
  color: #076b5c;
}

.ma-pdf-summary-item strong.is-deep {
  color: #054f44;
}

.ma-pdf-summary-item strong.is-amber {
  color: #c98a16;
}

.ma-pdf-summary-item strong.is-coral {
  color: #d14a3e;
}

.ma-pdf-summary-item.is-good {
  background: #e1f4f0;
  border-color: #b7e4da;
}

.ma-pdf-summary-item.is-good strong {
  color: #076b5c;
}

.ma-pdf-summary-item.is-warn {
  background: #faefda;
  border-color: #f0d9a8;
}

.ma-pdf-summary-item.is-warn strong {
  color: #84540a;
}

/* ——— Cards ——— */
.ma-pdf-card {
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  background: #fff;
  page-break-inside: avoid;
}

.ma-pdf-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  background: #f7fafa;
  border-bottom: 1px solid #eaf0f0;
}

.ma-pdf-card-head--teal {
  background: linear-gradient(90deg, #e1f4f0 0%, #f7fafa 70%);
  border-bottom-color: #c5e8e0;
}

.ma-pdf-card-head--navy {
  background: linear-gradient(90deg, #e8ecf7 0%, #f7fafa 70%);
  border-bottom-color: #d5dceb;
}

.ma-pdf-card-head h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0b1e2d;
}

.ma-pdf-card-sub {
  margin: 3px 0 0;
  font-size: 11px;
  color: #5f7484;
  line-height: 1.4;
}

.ma-pdf-legend {
  font-size: 10.5px;
  color: #5f7484;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  flex: none;
  margin-top: 2px;
}

.ma-pdf-swatch {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  background: #0d9b87;
  margin-right: 5px;
}

.ma-pdf-dash {
  display: inline-block;
  width: 14px;
  border-top: 1.5px dashed #b0730f;
  margin: 0 5px 2px 10px;
}

.ma-pdf-card-body {
  padding: 12px 14px 16px;
}

.ma-pdf-radar {
  background: radial-gradient(circle at 50% 45%, #f0faf8 0%, #fff 62%);
  border-radius: 8px;
}

.ma-pdf-radar svg {
  max-width: 100% !important;
  height: auto !important;
}

/* ——— Horizontal bars ——— */
.ma-pdf-hbars {
  display: grid;
  gap: 8px;
}

.ma-pdf-hbar {
  display: grid;
  grid-template-columns: 28px minmax(110px, 190px) 1fr 70px;
  gap: 10px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f7fafa;
  border: 1px solid #eaf0f0;
  page-break-inside: avoid;
}

.ma-pdf-hbar--teal {
  background: #f3faf8;
  border-color: #d5ebe6;
}

.ma-pdf-hbar--deep {
  background: #eef8f5;
  border-color: #c5e4dc;
}

.ma-pdf-hbar--amber {
  background: #fdf8ef;
  border-color: #f0e0bd;
}

.ma-pdf-hbar--coral {
  background: #fdf5f4;
  border-color: #f0d4cf;
}

.ma-pdf-hbar-rank {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: #00146d;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: grid;
  place-items: center;
  font-variant-numeric: tabular-nums;
}

.ma-pdf-hbar-label {
  font-size: 11px;
  color: #0b1e2d;
  line-height: 1.35;
  min-width: 0;
  font-weight: 500;
}

.ma-pdf-code {
  font-family: Consolas, 'Courier New', monospace;
  font-size: 10px;
  color: #076b5c;
  margin-right: 5px;
  font-weight: 700;
}

.ma-pdf-hbar-val {
  font-family: Consolas, 'Courier New', monospace;
  font-size: 11px;
  font-weight: 700;
  text-align: right;
  color: #0b1e2d;
  font-variant-numeric: tabular-nums;
}

.ma-pdf-hbar-val.is-teal {
  color: #076b5c;
}

.ma-pdf-hbar-val.is-deep {
  color: #054f44;
}

.ma-pdf-hbar-val.is-amber {
  color: #c98a16;
}

.ma-pdf-hbar-val.is-coral {
  color: #d14a3e;
}

.ma-pdf-empty {
  margin: 0;
  text-align: center;
  color: #8a9ba7;
  font-size: 12px;
  padding: 24px 8px;
}

/* ——— Footer ——— */
.ma-pdf-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f1f4fa;
  border: 1px solid #dfe7e8;
  font-size: 10px;
  color: #5f7484;
}

.ma-pdf-footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #00146d;
}

.ma-pdf-footer-dot {
  width: 8px;
  height: 8px;
  border-radius: 99px;
  background: #0d9b87;
}

@media print {
  .ma-pdf {
    width: auto;
    min-height: auto;
  }

  .ma-pdf-card,
  .ma-pdf-kpi,
  .ma-pdf-hbar,
  .ma-pdf-summary,
  .avoid-break {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .pdf-page-group {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pdf/maturity-analysis-pdf.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,eAAe;EACf,cAAc;EACd,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAE/C,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;EAC/B,OAAO;AACT;;AAEA;;;EAGE,sBAAsB;EAEtB,oCAAoC;EACpC,4EAA4E;EAC5E,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,uBAAuB;EACvB;kEACgE;EAChE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;;EAEhB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;;EAEhB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;;AAEnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;;EAEhB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;;EAEhB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;;EAEhB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;;;IAKE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":["/* Maturity Analysis — print / PDF export (polished layout) */\n\n.ma-pdf-print-host {\n  position: fixed;\n  left: -10000px;\n  top: 0;\n  width: 210mm;\n  background: #fff;\n  z-index: -1;\n  pointer-events: none;\n  /* Keep in layout for React; capture uses a clone, not this host */\n}\n\n.ma-pdf {\n  box-sizing: border-box;\n  width: 794px;\n  max-width: 794px;\n  min-height: 0;\n  padding: 0 0 40px;\n  margin: 0;\n  background: #fff;\n  color: #0b1e2d;\n  font-family: Lato, Helvetica, Arial, sans-serif;\n  -webkit-print-color-adjust: exact !important;\n  print-color-adjust: exact !important;\n  letter-spacing: 0 !important;\n  word-spacing: normal !important;\n  zoom: 1;\n}\n\n.ma-pdf *,\n.ma-pdf *::before,\n.ma-pdf *::after {\n  box-sizing: border-box;\n  -webkit-print-color-adjust: exact !important;\n  print-color-adjust: exact !important;\n  /* html2canvas corrupts non-zero letter-spacing (overlap / missing spaces) */\n  letter-spacing: 0 !important;\n  word-spacing: normal !important;\n}\n\n/* ——— Hero ——— */\n.ma-pdf-hero {\n  margin: 0 0 16px;\n  padding: 60px 60px 14px;\n  background:\n    linear-gradient(135deg, #00146d 0%, #062a63 42%, #076b5c 100%);\n  color: #fff;\n}\n\n.ma-pdf-hero-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.ma-pdf-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ma-pdf-brand-mark {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n}\n\n.ma-pdf-brand-mark img {\n  width: 26px;\n  height: 26px;\n  object-fit: contain;\n  display: block;\n}\n\n.ma-pdf-brand-name {\n  display: block;\n  font-size: 15px;\n  font-weight: 800;\n\n  color: #fff;\n}\n\n.ma-pdf-brand-tag {\n  display: block;\n  margin-top: 2px;\n  font-size: 10px;\n  font-weight: 600;\n\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.ma-pdf-date-chip {\n  text-align: right;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.ma-pdf-date-label {\n  display: block;\n  font-size: 9.5px;\n  font-weight: 700;\n\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 2px;\n}\n\n.ma-pdf-date-chip strong {\n  font-size: 12.5px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #fff;\n}\n\n.ma-pdf-eyebrow {\n  margin: 0 0 6px;\n  font-size: 10.5px;\n  font-weight: 700;\n\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.ma-pdf-title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.15;\n\n}\n\n.ma-pdf-sub {\n  margin: 8px 0 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.82);\n  max-width: 540px;\n}\n\n.ma-pdf-scale {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.ma-pdf-scale-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 10.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ma-pdf-scale-item i {\n  width: 9px;\n  height: 9px;\n  border-radius: 99px;\n  display: inline-block;\n}\n\n/* ——— Section labels / body padding ——— */\n.ma-pdf-section-label {\n  margin: 0 60px 8px;\n  font-size: 10px;\n  font-weight: 800;\n\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.ma-pdf-kpi-grid,\n.ma-pdf-card,\n.ma-pdf-summary,\n.ma-pdf-footer {\n  margin-left: 60px;\n  margin-right: 60px;\n}\n\n/* ——— KPIs ——— */\n.ma-pdf-kpi-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.ma-pdf-kpi {\n  position: relative;\n  background: #f7fafa;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  padding: 14px 16px 14px 18px;\n  overflow: hidden;\n}\n\n.ma-pdf-kpi::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  background: #cdd8d6;\n}\n\n.ma-pdf-kpi--teal::before {\n  background: #0d9b87;\n}\n\n.ma-pdf-kpi--deep::before {\n  background: #076b5c;\n}\n\n.ma-pdf-kpi--amber::before {\n  background: #c98a16;\n}\n\n.ma-pdf-kpi--coral::before {\n  background: #d14a3e;\n}\n\n.ma-pdf-kpi--muted::before {\n  background: #8a9ba7;\n}\n\n.ma-pdf-kpi-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.ma-pdf-kpi-label {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 700;\n\n  text-transform: uppercase;\n  color: #5f7484;\n  line-height: 1.35;\n  max-width: 70%;\n}\n\n.ma-pdf-pill {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 99px;\n  font-size: 10px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.ma-pdf-pill--teal {\n  background: #e1f4f0;\n  color: #076b5c;\n}\n\n.ma-pdf-pill--deep {\n  background: #d5ebe6;\n  color: #054f44;\n}\n\n.ma-pdf-pill--amber {\n  background: #faefda;\n  color: #84540a;\n}\n\n.ma-pdf-pill--coral {\n  background: #fae6e3;\n  color: #96271b;\n}\n\n.ma-pdf-pill--muted {\n  background: #eaf0f0;\n  color: #5f7484;\n}\n\n.ma-pdf-kpi-value {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 1.05;\n  color: #0b1e2d;\n  font-variant-numeric: tabular-nums;\n}\n\n.ma-pdf-kpi-value.is-teal {\n  color: #076b5c;\n}\n\n.ma-pdf-kpi-value.is-deep {\n  color: #054f44;\n}\n\n.ma-pdf-kpi-value.is-amber {\n  color: #c98a16;\n}\n\n.ma-pdf-kpi-value.is-coral {\n  color: #d14a3e;\n}\n\n.ma-pdf-kpi-value.is-muted {\n  color: #8a9ba7;\n}\n\n.ma-pdf-kpi-desc {\n  margin: 8px 0 0;\n  font-size: 11px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.ma-pdf-bar {\n  height: 8px;\n  border-radius: 99px;\n  background: #eaf0f0;\n  margin-top: 12px;\n  overflow: hidden;\n}\n\n.ma-pdf-bar span {\n  display: block;\n  height: 100%;\n  border-radius: 99px;\n  min-width: 0;\n}\n\n.ma-pdf-bar--row {\n  margin-top: 0;\n  height: 10px;\n}\n\n/* ——— Summary strip ——— */\n.ma-pdf-summary {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.ma-pdf-summary-item {\n  background: #f7fafa;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.ma-pdf-summary-item span {\n  display: block;\n  font-size: 9.5px;\n  font-weight: 700;\n\n  text-transform: uppercase;\n  color: #8a9ba7;\n  margin-bottom: 4px;\n}\n\n.ma-pdf-summary-item strong {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0b1e2d;\n  font-variant-numeric: tabular-nums;\n}\n\n.ma-pdf-summary-item strong.is-teal {\n  color: #076b5c;\n}\n\n.ma-pdf-summary-item strong.is-deep {\n  color: #054f44;\n}\n\n.ma-pdf-summary-item strong.is-amber {\n  color: #c98a16;\n}\n\n.ma-pdf-summary-item strong.is-coral {\n  color: #d14a3e;\n}\n\n.ma-pdf-summary-item.is-good {\n  background: #e1f4f0;\n  border-color: #b7e4da;\n}\n\n.ma-pdf-summary-item.is-good strong {\n  color: #076b5c;\n}\n\n.ma-pdf-summary-item.is-warn {\n  background: #faefda;\n  border-color: #f0d9a8;\n}\n\n.ma-pdf-summary-item.is-warn strong {\n  color: #84540a;\n}\n\n/* ——— Cards ——— */\n.ma-pdf-card {\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 16px;\n  background: #fff;\n  page-break-inside: avoid;\n}\n\n.ma-pdf-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px;\n  background: #f7fafa;\n  border-bottom: 1px solid #eaf0f0;\n}\n\n.ma-pdf-card-head--teal {\n  background: linear-gradient(90deg, #e1f4f0 0%, #f7fafa 70%);\n  border-bottom-color: #c5e8e0;\n}\n\n.ma-pdf-card-head--navy {\n  background: linear-gradient(90deg, #e8ecf7 0%, #f7fafa 70%);\n  border-bottom-color: #d5dceb;\n}\n\n.ma-pdf-card-head h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.ma-pdf-card-sub {\n  margin: 3px 0 0;\n  font-size: 11px;\n  color: #5f7484;\n  line-height: 1.4;\n}\n\n.ma-pdf-legend {\n  font-size: 10.5px;\n  color: #5f7484;\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  flex: none;\n  margin-top: 2px;\n}\n\n.ma-pdf-swatch {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border-radius: 2px;\n  background: #0d9b87;\n  margin-right: 5px;\n}\n\n.ma-pdf-dash {\n  display: inline-block;\n  width: 14px;\n  border-top: 1.5px dashed #b0730f;\n  margin: 0 5px 2px 10px;\n}\n\n.ma-pdf-card-body {\n  padding: 12px 14px 16px;\n}\n\n.ma-pdf-radar {\n  background: radial-gradient(circle at 50% 45%, #f0faf8 0%, #fff 62%);\n  border-radius: 8px;\n}\n\n.ma-pdf-radar svg {\n  max-width: 100% !important;\n  height: auto !important;\n}\n\n/* ——— Horizontal bars ——— */\n.ma-pdf-hbars {\n  display: grid;\n  gap: 8px;\n}\n\n.ma-pdf-hbar {\n  display: grid;\n  grid-template-columns: 28px minmax(110px, 190px) 1fr 70px;\n  gap: 10px;\n  align-items: center;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #f7fafa;\n  border: 1px solid #eaf0f0;\n  page-break-inside: avoid;\n}\n\n.ma-pdf-hbar--teal {\n  background: #f3faf8;\n  border-color: #d5ebe6;\n}\n\n.ma-pdf-hbar--deep {\n  background: #eef8f5;\n  border-color: #c5e4dc;\n}\n\n.ma-pdf-hbar--amber {\n  background: #fdf8ef;\n  border-color: #f0e0bd;\n}\n\n.ma-pdf-hbar--coral {\n  background: #fdf5f4;\n  border-color: #f0d4cf;\n}\n\n.ma-pdf-hbar-rank {\n  width: 24px;\n  height: 24px;\n  border-radius: 7px;\n  background: #00146d;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  display: grid;\n  place-items: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.ma-pdf-hbar-label {\n  font-size: 11px;\n  color: #0b1e2d;\n  line-height: 1.35;\n  min-width: 0;\n  font-weight: 500;\n}\n\n.ma-pdf-code {\n  font-family: Consolas, 'Courier New', monospace;\n  font-size: 10px;\n  color: #076b5c;\n  margin-right: 5px;\n  font-weight: 700;\n}\n\n.ma-pdf-hbar-val {\n  font-family: Consolas, 'Courier New', monospace;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: right;\n  color: #0b1e2d;\n  font-variant-numeric: tabular-nums;\n}\n\n.ma-pdf-hbar-val.is-teal {\n  color: #076b5c;\n}\n\n.ma-pdf-hbar-val.is-deep {\n  color: #054f44;\n}\n\n.ma-pdf-hbar-val.is-amber {\n  color: #c98a16;\n}\n\n.ma-pdf-hbar-val.is-coral {\n  color: #d14a3e;\n}\n\n.ma-pdf-empty {\n  margin: 0;\n  text-align: center;\n  color: #8a9ba7;\n  font-size: 12px;\n  padding: 24px 8px;\n}\n\n/* ——— Footer ——— */\n.ma-pdf-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 8px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #f1f4fa;\n  border: 1px solid #dfe7e8;\n  font-size: 10px;\n  color: #5f7484;\n}\n\n.ma-pdf-footer-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  color: #00146d;\n}\n\n.ma-pdf-footer-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 99px;\n  background: #0d9b87;\n}\n\n@media print {\n  .ma-pdf {\n    width: auto;\n    min-height: auto;\n  }\n\n  .ma-pdf-card,\n  .ma-pdf-kpi,\n  .ma-pdf-hbar,\n  .ma-pdf-summary,\n  .avoid-break {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .pdf-page-group {\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
